import { useState } from "react";
import { Row, Grid, Button } from "antd";
import UberEatsDisconnectDialog from "./UberEatsDisconnectDialog";

const { useBreakpoint } = Grid;

export default function UberEatsDisconnect({ isLoading, handleProvision }) {
  const screens = useBreakpoint();
  const [showModal, setShowModal] = useState(false);

  return (
    <>
      <Row
        justify="end"
        style={{ margin: screens.xl ? "3% 18%" : screens.lg ? "3% 10%" : "3% 3%" }}
      >
        <Button
          color="danger"
          variant="solid"
          size="large"
          block={screens.md ? false : true}
          onClick={() => setShowModal(true)}
        >
          DISCONNECT
        </Button>
      </Row>
      <UberEatsDisconnectDialog
        showModal={showModal}
        setShowModal={setShowModal}
        isLoading={isLoading}
        handleProvision={handleProvision}
      />
    </>
  );
};